import { LabelProps, Label } from './Label';
export function LabelBreadcrumbsActive(props: LabelProps) {
    return <Label variant="text-breadcrumbs-active" {...props} />;
}
